"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimentsApi = void 0;
const handlers_1 = require("../handlers");
exports.experimentsApi = (http, prefix = '/experiment') => ({
    getExperimentsByCustomer(customerId) {
        return http.get(`${prefix}/flag/batch/customer/${customerId}`).catch(handlers_1._404([]));
    },
    getExperimentsByProperty(propertyId) {
        return http.get(`${prefix}/flag/batch/property/${propertyId}`).catch(handlers_1._404([]));
    },
    sendCustomerEvent(customerId, event) {
        return http.post(`${prefix}/event/customer/${customerId}`, event);
    },
    sendPropertyEvent(propertyId, event) {
        return http.post(`${prefix}/event/property/${propertyId}`, event);
    },
});
//# sourceMappingURL=index.js.map